import { useSelector } from "react-redux";
import { makeSelectIsUserInTutorial } from "modules/userStatus/redux/selectors";
import { useMemo } from "react";
import { selectUser, selectUserIsSyncStatus } from "../redux/selectors";

const useLoginUser = () => {
  const user = useSelector(selectUser);
  const userId = useMemo(() => (user ? user.id : null), [user]);
  const isMeInTutorial = useSelector(makeSelectIsUserInTutorial(userId ?? ""));
  const isTokenSyncedWithServer = useSelector(selectUserIsSyncStatus);

  return {
    user,
    isMeInTutorial,
    userId,
    isTokenSyncedWithServer,
  };
};

export default useLoginUser;
